export default __webpack_public_path__ + "static/home-banner-27fdea2af9cbe368b01907265e3eaaae.jpg";